import axios from 'axios';
import api, { baseURL } from './api';

export interface GetAssignedUrlResponse {
  url: string;
  filename: string;
  image_url: string;
  key: string;
}

export const getAssignedUrl = async (filename: string, path: string) => {
  const { data } = await api.get<GetAssignedUrlResponse>(
    `${baseURL}bucket/${path}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      params: {
        filename,
      },
    },
  );
  return data;
};

export const sendBucketImage = async (file: File, assignedUrl: string) => {
  const { data } = await axios.put(assignedUrl, file, {
    headers: {
      'Content-Type': file.type,
      'Cache-Control': 'public,max-age=31536000,immutable',
      'x-amz-acl': 'public-read',
    },
  });
  return data;
};

export const deleteBucketImage = async (filepath: string) => {
  const { data } = await axios.delete(`${baseURL}bucket/delete`, {
    params: {
      filepath,
    },
  });
  return data;
};
